import type { Me, Membership, OrgType, Side } from '../api/types';

/** Контекст организации: uuid одной организации или «все мои клиники / лаборатории». */
export type Ctx = string; // uuid | 'all-clinics' | 'all-labs'
export const ALL_CLINICS = 'all-clinics';
export const ALL_LABS = 'all-labs';

export type Mode = 'admin' | 'doctor' | 'lab' | 'none';

const ofType = (ms: Membership[], type: OrgType) => ms.filter((m) => m.org_type === type);

/** Допустимые значения контекста (validCtx прототипа). */
export function validCtx(ms: Membership[]): Ctx[] {
  const cl = ofType(ms, 'clinic');
  const lb = ofType(ms, 'lab');
  return ms.map((m) => m.org_id).concat(cl.length > 1 ? [ALL_CLINICS] : [], lb.length > 1 ? [ALL_LABS] : []);
}

/** Сохранённый контекст, если он ещё допустим, иначе первая организация. */
export function resolveCtx(stored: string | null, ms: Membership[]): Ctx | null {
  if (stored && validCtx(ms).includes(stored)) return stored;
  return ms.length ? ms[0].org_id : null;
}

/** Режим интерфейса (mode() прототипа). Администратор в режиме поддержки видит кабинет пользователя. */
export function modeOf(me: Pick<Me, 'is_platform_admin' | 'support' | 'memberships'>, ctx: Ctx | null): Mode {
  if (!me.support && me.is_platform_admin) return 'admin';
  if (ctx === ALL_CLINICS) return 'doctor';
  if (ctx === ALL_LABS) return 'lab';
  if (!ctx) return 'none';
  const m = me.memberships.find((x) => x.org_id === ctx);
  if (!m) return 'none';
  return m.org_type === 'lab' ? 'lab' : 'doctor';
}

/** Организации текущего контекста (ctxOrgs прототипа). */
export function ctxOrgs(ms: Membership[], ctx: Ctx | null): Membership[] {
  if (ctx === ALL_CLINICS) return ofType(ms, 'clinic');
  if (ctx === ALL_LABS) return ofType(ms, 'lab');
  return ms.filter((m) => m.org_id === ctx);
}

/** Параметр org для API: для «всех моих» не передаётся. */
export const ctxOrgParam = (ctx: Ctx | null): string | undefined =>
  !ctx || ctx === ALL_CLINICS || ctx === ALL_LABS ? undefined : ctx;

export const sideOf = (mode: Mode): Side => (mode === 'lab' ? 'lab' : 'clinic');

export const HOME: Record<Mode, string> = {
  doctor: '/cases',
  lab: '/board',
  admin: '/admin/users',
  none: '/no-access',
};
